export default "__VITE_ASSET__CfoK3t_Q__"